/*
 * Drifts the About page banner image against the scroll position.
 * The media box is inset by -12% top/bottom, so the image can travel that far
 * in either direction without exposing an edge.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = Array.from(document.querySelectorAll('[data-about-parallax]'));
  if (targets.length === 0) return;

  let ticking = false;

  function update() {
    ticking = false;
    const viewport = window.innerHeight;

    targets.forEach((media) => {
      const frame = media.parentElement;
      const rect = frame.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewport) return;

      // -1 when the frame sits just below the fold, 1 when it has just left the top.
      const progress = 1 - (2 * (rect.top + rect.height / 2)) / (viewport + rect.height);
      media.style.transform = 'translate3d(0, ' + (progress * 6).toFixed(2) + '%, 0)';
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
